import React, { useCallback, useMemo, useState } from 'react';
import { AppButton, Box, Dropdown, OptionKey, Preloader, SearchInput, Text } from '@common-fe/common-fe';

import CheckboxDropdownGroup from '../CheckboxDropdownGroup';
import { useRolesAllowedToCreateQuery } from '../queries';



interface Props {
  values: OptionKey[];
  disabled?: boolean;
  onChangeValues: (values: OptionKey[]) => void;
}
const RolesDropdown: React.FC<Props> = ({ values, onChangeValues,disabled }) => {
  const [currentValues, setCurrentValues] = useState<OptionKey[]>([]);
  const [currentSearch, setCurrentSearch] = useState('');
  const [expanded, setExpanded] = useState(false);

  const { groups, options, isLoading } = useRolesAllowedToCreateQuery({ 
    disabled
  });
  
  const currentTitle = useMemo(() => {
    if(currentValues.length) {
      const filteredOptions = options.filter((item) => currentValues.includes(item.id));
      return filteredOptions.map((item) => item.title).join(', ');
    }
    return 'All';
  }, [currentValues, options]);

  const handleCancel = useCallback(() => {
    setExpanded(false);
    
    setCurrentValues(values);
  }, [values]);
  const handleApply = useCallback(() => {

    onChangeValues(currentValues);
    setExpanded(false);

  }, [currentValues, onChangeValues]);

  return (
    <Box width="240px" data-testid="roles-level_dropdown">
      <Dropdown
        placeholder="Placeholder"
        isClickOutside={false}
        prefix="Permission"
        testId='role'
        disabled={disabled}
        expanded={expanded}
        title={(
          <Text title={currentTitle} color={disabled ?'textDisabled' : 'textAccent'} truncate>
            {currentTitle}
          </Text>
        )}
        onSetExpanded={setExpanded}
        contentStyles={{
          elevation: 'active',
          style: {
            left: '',
            right: '0px',
            minWidth: '340px',
          },
        }}
      >
        <Box direction="column">
          <Box pad="m" direction="column">
            <SearchInput
              value={currentSearch}
              testId='role-dropdown'
              defaultValue={currentSearch}
              placeholder="Search"
              onChange={setCurrentSearch}
            />
          </Box>

          <Box
            pad={{ top: 'xs', left: 'm', right: 'm', bottom: 'm' }}
            border={{ side: 'horizontal', size: 'small', color: 'border1' }}
            style={{ overflow: 'auto' }}
            height="290px"
          >
            <div>
              {groups.map((group) => (
                <CheckboxDropdownGroup
                  isSelectedMode={false}
                  defaultExpanded
                  key={group.id}
                  id={group.id}
                  searchString={currentSearch}
                  name={group.name}
                  values={currentValues}
                  onChangeValues={setCurrentValues}
                  options={group.options}
                />
              ))}
              {isLoading && <Preloader />}
            </div>
          </Box>

          <Box pad="m" direction="row">
            <Box margin={{ right: 'spacing6' }}>
              <AppButton testId="role_dropdown_cancel" width="145px" buttonType="secondary" onClick={handleCancel}>
                Cancel
              </AppButton>
            </Box>
            <Box margin={{ left: 'spacing6' }}>
              <AppButton testId="role_dropdown_apply" width="145px" onClick={handleApply}>
                Apply
              </AppButton>
            </Box>
          </Box>
        </Box>
      </Dropdown>
    </Box>
  );
};
export default React.memo(RolesDropdown);
